import {l} from "../../../types/typescriptdefinisjoner_lederplan";
import _ from "lodash";
import {Datoer} from "../Datoer";
import moment from "moment/moment";

export class Møtedatoer {

    static erFlerdagsmøte(dato:l.MøteDato){
        if (_.isNil(dato.start) || _.isNil(dato.slutt)) return false;
        return dato.start.getDate() != dato.slutt.getDate();
    }

    static møtevarighetIAntallDager(dato: l.MøteDato) {
        const start = Datoer.datoMedKlokkeslett(dato.start, '12:00');
        const slutt = Datoer.datoMedKlokkeslett(dato.slutt, '12:00');
        const antallDager = moment(slutt).diff(start, 'days')
        return antallDager + 1;
    }

}
